import NoSleep from "../lib/nosleep.js/index.js";

class WakeLockService {
    constructor () {
        this.noSleep = new NoSleep();
    }   

    wakeLockEnabled () {
        if (navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('GSA') > -1) return false;
        return true;
    }

    /**
     * Enables the wake lock
     */
    enable () {
        if (!this.wakeLockEnabled()) return;
        console.log("[WAKE LOCK] - enable")
        this.noSleep.enable();
        		// Add notification to confirm before refreshing the page
        window.addEventListener("beforeunload", this.refreshLockHandler)

    }

    /**
     * Disables the wake lock
     */
    disable () {
        if (!this.wakeLockEnabled()) return;
        console.log("[WAKE LOCK] - disable")
        this.noSleep.disable();
        window.removeEventListener("beforeunload", this.refreshLockHandler);
    }

    refreshLockHandler (e) {
        var dialogText = 'Weet je zeker dat je de game wil afsluiten?';
        e.returnValue = dialogText;
        return dialogText;
    }
}

const wakeLockService = new WakeLockService();
export default wakeLockService;


// WEBPACK FOOTER //
// ./src/services/WakeLockService.js